import { createAction, union } from '@ngrx/store';
import { Restaurant } from '../../../models/restaurant/restaurant';
import { RestaurantKey } from '../../../models/restaurant/restaurant-key';
import { UserReservation } from '../../../models/user-reservation/user-reservation';

interface InitRestaurantPagePayload {
  startsFromTime: string;
  showWebReservation: boolean;
  restaurantKey: RestaurantKey;
  canUseWebShareAPI: boolean;
}

export const initRestaurantPage = createAction(
  'RestarurantPageActions initRestaurantPage',
  (payload: InitRestaurantPagePayload) => ({ payload }),
);

export const storeShowWebReservation = createAction(
  'RestarurantPageActions storeShowWebReservation',
  (payload: boolean) => ({ payload }),
);

export const clearRestaurantPage = createAction(
  'RestarurantPageActions clearShowWebReservation',
);

export const storeStartsFromTime = createAction(
  'RestarurantPageActions storeStartsFromTime',
  (payload: string) => ({ payload }),
);

export const storeRestaurantKey = createAction(
  'RestaurantPageActions storeRestaurantKey',
  (payload: RestaurantKey) => ({ payload }),
);
const all = union({
  initRestaurantPage,
  storeShowWebReservation,
  clearRestaurantPage,
  storeRestaurantKey,
});
export type RestaurantPageActionsUnion = typeof all;
